import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { BookingSection } from "./BookingSection";
import DailyDareSection from "./DailyDareSection";
import { StatsSection } from "./StatsSection";
import StepSection from "./StepSection";
import HeroSection from "./HeroSection";
import CheckinSection from "./CheckinSection";
import { useUserContext } from "@/contexts/user";
import PracticeForBalanceSection from "./PracticeForBalanceSection";
import { cn } from "@/lib/utils";
import { ErrorBoundary2 } from "../ErrorBoundary2";
import { NavigationProvider } from "@/contexts/navigation/provider";
import { DailyCheckinProvider } from "@/contexts/dailyCheckin/provider";
import { UnsavedChangesProvider } from "@/contexts/unsavedChanges/provider";
import { HelloSection } from "./HelloSection";
import { BackToTopButton } from "@/components/BackToTopButton";
import { AllowNotificationsHandler } from "@/components/AllowNotificationsHandler";
import { AppContentProvider } from "@/contexts/appContent/AppContentProvider";
import { useSectionCompleteConfetti } from "@/hooks/useSectionCompleteConfetti";
import { ConfettiProvider } from "@/contexts/confetti";

const Index = () => {
  const navigate = useNavigate();
  const continueJourneyRef = useRef(null);
  const dailyRef = useRef(null);
  const scrollToTopThresholdRef = useRef(null);
  const containerRef = useRef(null);

  return (
    <div className="h-full relative">
      <div
        ref={containerRef}
        className={cn(
          "bg-background h-full overflow-y-auto overflow-x-hidden [transform:translateZ(0)]",
          // popup && "overflow-hidden"
        )}>

        <AllowNotificationsHandler />

        {/* Hero Section */}
        <NavigationProvider>
          <DailyCheckinProvider>
            <AppContentProvider>
              <ConfettiProvider>
              <ErrorBoundary2 msg="HeroSection">
                <HeroSection
                  continueJourneyRef={continueJourneyRef}
                  dailyRef={dailyRef}
                />
                <div ref={scrollToTopThresholdRef} />
              </ErrorBoundary2>

              <LoggedInContent
                continueJourneyRef={continueJourneyRef}
                dailyRef={dailyRef}
              />

              {/* Community Feature */}
              <ErrorBoundary2 msg="BookingSection">
                <BookingSection />
              </ErrorBoundary2>

              </ConfettiProvider>
            </AppContentProvider>
          </DailyCheckinProvider>
        </NavigationProvider>
      </div>
      <BackToTopButton scrollContainerRef={containerRef} visibleThresholdRef={scrollToTopThresholdRef} />
    </div>
  );
};

function LoggedInContent({ continueJourneyRef, dailyRef }) {
  const { user, profile } = useUserContext();
  useSectionCompleteConfetti();
  return (
    user && (
      <ErrorBoundary2 msg="StatsProvider">
        <ErrorBoundary2 msg="UserName">
          <HelloSection name={profile?.first_name} ref={dailyRef} />
        </ErrorBoundary2>

        <ErrorBoundary2 msg="CheckinSection">
          <CheckinSection />
        </ErrorBoundary2>

        <ErrorBoundary2 msg="DailyDareSection">
          <DailyDareSection />
        </ErrorBoundary2>

        <ErrorBoundary2 msg="PracticeForBalanceSection">
          <PracticeForBalanceSection />
        </ErrorBoundary2>

        {/* <ErrorBoundary2 msg="ProgressOverviewSection">
          <ProgressOverviewSection />
        </ErrorBoundary2> */}

        <ErrorBoundary2 msg="StatsSection">
          <StatsSection />
        </ErrorBoundary2>

        <ErrorBoundary2 msg="StepSection">
          <UnsavedChangesProvider>
            <StepSection ref={continueJourneyRef} />
          </UnsavedChangesProvider>
        </ErrorBoundary2>
      </ErrorBoundary2>
    )
  );
}

export default Index;